/**
 * Created by mac on 12/11/20
 */

const Unit = function (options) {
    this.__instanceId = classManager.getNewInstanceId();

    this.load(options);

    const location = cleverapps.meta.getSelectedLocation();
    if (location.families && !location.families[this.code]) {
        cleverapps.throwAsync(`Unit from other world - ${this.getKey()}`);
    }

    this.additionalViewsHidden = false;
};

Unit.prototype.onInfoOpened = function () {
    this.components.forEach((component) => {
        if (component.onInfoOpened) {
            component.onInfoOpened();
        }
    });
};

Unit.prototype.onInfoClosed = function (withAction) {
    this.components.forEach((component) => {
        if (component.onInfoClosed) {
            component.onInfoClosed(withAction);
        }
    });
};

Unit.prototype.onPrizeHarvested = function () {
    this.components.forEach((component) => {
        if (component.onPrizeHarvested) {
            component.onPrizeHarvested();
        }
    });
};

Unit.prototype.onPrizeNotHarvested = function () {
    this.components.forEach((component) => {
        if (component.onPrizeNotHarvested) {
            component.onPrizeNotHarvested();
        }
    });
};

Unit.prototype.onNeedToBeRemoved = function () {
    this.components.forEach((component) => {
        if (component.onNeedToBeRemoved) {
            component.onNeedToBeRemoved();
        }
    });
};

Unit.prototype.setView = function (view) {
    this.view = view;
};

Unit.prototype.removeView = function () {
    if (this.view) {
        this.view.removeAdditionalViews && this.view.removeAdditionalViews();
        this.view = undefined;
    }

    this.components.forEach((component) => {
        component.removeView();
    });
};

Unit.prototype.onGetView = function () {
    return this.view;
};

Unit.prototype.checkTouchInside = function (touch, isTallUnit) {
    let result = false;
    if (this.view) {
        result = this.view.checkTouchInside(touch, isTallUnit);
    }

    for (const component of this.components) {
        if (component.checkTouchInside) {
            result = result || component.checkTouchInside(touch, isTallUnit);
        }
    }

    return result;
};

Unit.prototype.onClickEvent = function (touch) {
    if (this.view) {
        return this.view.handleClick(touch);
    }
};

Unit.prototype.onDragStart = function (touch) {
    if (this.view) {
        return this.view.handleDragStart(touch);
    }
};

Unit.prototype.onDragMove = function () {
    if (this.view) {
        this.view.handleDragMove();
    }
};

Unit.prototype.onFollowPointer = function (touch) {
    if (this.view) {
        this.view.handleFollowPointer(touch);
    }
};

Unit.prototype.onDragEnd = function (cancelled) {
    if (this.view) {
        this.view.handleDragEnd(cancelled);
    }
};

Unit.prototype.onShowUp = function (callback) {
    if (this.view && this.view.showUp) {
        this.view.showUp(callback);
    } else {
        callback();
    }
};

Unit.prototype.onAdd = function () {
    if (this.view) {
        this.view.playAddAnimation();
    }
};

Unit.prototype.onDestruction = function (silent, originUnit) {
    if (this.view) {
        this.view.playDestruction(silent, originUnit);
    }
};

Unit.prototype.onRemove = function () {
    if (this.view) {
        this.view.onRemove();
    }
};

Unit.prototype.onTradeSell = function (callback) {
    if (this.view) {
        this.view.onTradeSell(callback);
    } else {
        callback();
    }
};

Unit.prototype.onTradeBuy = function (callback) {
    if (this.view) {
        this.view.onTradeBuy(callback);
    } else {
        callback();
    }
};

Unit.prototype.onMove = function (options) {
    if (this.view) {
        this.view.move(options);
    }
};

Unit.prototype.onStartDidMerged = function () {
    if (this.view) {
        this.view.startDidMerged();
    }
};

Unit.prototype.onDidMerged = function (startPoint, index) {
    if (this.view) {
        this.view.didMerged(startPoint, index);
    }
};

Unit.prototype.onMerge = function (target) {
    if (this.view) {
        this.view.merge(target);
    }
};

Unit.prototype.onStartAnimateMerge = function (target) {
    if (this.view) {
        this.view.startAnimateMerge(target);
    }
};

Unit.prototype.onStopAnimateMerge = function (target) {
    if (this.view) {
        this.view.stopAnimateMerge(target);
    }
};

Unit.prototype.onSqueeze = function () {
    if (this.view) {
        this.view.squeeze();
    }
};
Unit.prototype.onSpawned = function (parentUnit, id, options) {
    options = options || {};

    if (this.view) {
        this.view.spawn(parentUnit, id, options);
    } else if (options.callback) {
        options.callback();
    }
};

Unit.prototype.onPrizeChanged = function () {
    if (this.view) {
        this.view.restoreState();
        this.view.animatePrizeView();
    }
};

Unit.prototype.onUpdateCustomerMark = function () {
    if (this.view) {
        this.view.updateCustomerMark();
    }
};

Unit.prototype.onMarkError = function () {
    if (this.view) {
        this.view.markError();
    }
};

Unit.prototype.onMarkNormal = function () {
    if (this.view) {
        this.view.markNormal();
    }
};

Unit.prototype.onMarkDragging = function () {
    if (this.view) {
        this.view.markDragging();
    }
};

Unit.prototype.onShowPoints = function () {
    if (this.view) {
        this.view.animateAppearPoints();
    }
};

Unit.prototype.onHidePoints = function () {
    if (this.view) {
        this.view.hidePoints();
    }
};

Unit.prototype.onClaimPoints = function (callback) {
    if (this.view) {
        this.view.claimPoints(callback);
    } else {
        callback();
    }
};

Unit.prototype.onGetDnDAccepted = function (targetUnit) {
    if (this.view) {
        this.view.getDnDAccepted(targetUnit);
    }
};

Unit.prototype.onShowFresh = function () {
    if (this.view) {
        this.view.showFreshAnimation();
    }
};

Unit.prototype.onDialogueStart = function () {
    if (this.view) {
        this.view.dialogueAnimation("dialogue_start", "dialogue_idle");
    }
};

Unit.prototype.onDialogueEnd = function () {
    if (this.view) {
        this.view.dialogueAnimation("dialogue_end");
    }
};

Unit.prototype.onCollectIngredients = function (collected) {
    if (this.view) {
        this.view.collectIngredients(this, collected, () => {
            Map2dLocation.currentLocation.harvested.onChange();
        });
    } else {
        Map2dLocation.currentLocation.harvested.onChange();
    }
};

Unit.prototype.getResource = function () {
    return Families[this.code].resource;
};

Unit.prototype.getType = function () {
    return Families[this.code].type;
};

Unit.prototype.playClickSound = function () {
    if (this.isBuilt()) {
        if (this.isCastle() || (this.getType() === "resource" && this.stage === UnitsLibrary.LastStage(this.code).stage - 1)) {
            cleverapps.effects.fire(`unit.click.castle.${this.code}`);
        }
    }
};

Unit.prototype.getData = function () {
    return Families[this.code].units[this.stage];
};

Unit.prototype.isUnmergeable = function () {
    const data = this.getData();
    if (data.unmergeable) {
        return true;
    }
    if (data.unmergeableIn && data.unmergeableIn[cleverapps.meta.selectedLocationId()]) {
        return true;
    }
    return false;
};

Unit.prototype.load = function (stored) {
    this.code = stored.code;
    this.stage = stored.stage;
    this.prizesCount = stored.prizesCount;

    if (typeof this.code !== "string" || !Families[this.code] || !Families[this.code].units[this.stage]) {
        throw `creating unknown unit ${this.code} ${this.stage}`;
    }

    const unitData = this.getData();

    if (unitData.stopsfog && stored.grounded !== undefined) {
        this.stopsfog = stored.grounded === 1;
    }

    if (stored.points) {
        if (cleverapps.missionManager.findLocalPass()) {
            this.points = stored.points;
            this.pointsHandler = cleverapps.missionManager.on("erasePassPoints", (destructedMap) => this.setPoints(0, destructedMap));
        }
    }

    if (stored._data) {
        this._data = stored._data;
    }

    this.shape = Unit.GetShape(this);

    this.components = [];
    ComponentsFactory(this.components, this, stored);
};

Unit.prototype.getInfo = function () {
    let data = {
        stage: this.stage,
        code: this.code,
        prizesCount: this.prizesCount
    };

    if (this.stopsfog !== undefined) {
        data.grounded = this.stopsfog ? 1 : 0;
    }

    if (this.points) {
        if (cleverapps.missionManager.findLocalPass()) {
            data.points = this.points;
        }
    }

    this.components.forEach((component) => {
        if (component.save) {
            component.save(data);
        }
    });

    const wasIntact = this.intact;

    if (this.intact) {
        this.intact = undefined;
        this.removeFromMap(true);
    }

    if (this._data) {
        data._data = this._data;
    }

    if (this.isIntact(data)) {
        this.intact = true;
        if (!wasIntact) {
            this.removeFromMap();
        }
        data = { code: "intact", stage: 0 };
    }

    return data;
};

Unit.prototype.save = function () {
    const location = cleverapps.meta.getSelectedLocation();
    if (location.families && !location.families[this.code]) {
        cleverapps.throwAsync(`Save unit to other world - ${Unit.GetKey(this)}`);
        return;
    }

    this.saveInMap();
};

Unit.prototype.saveInMap = function () {
    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return;
    }

    if (this.isLifted() || Unit.DISABLED_CODES[this.code]) {
        return;
    }

    if (!cleverapps.config.saveUnitsEnabled) {
        return;
    }

    let info = this.getInfo();

    if (info.code === "unknown") {
        if (!info._data) {
            return;
        }
        info = info._data;
    }

    if (cleverapps.config.name === "wordsoup") {
        WordsoupMapSaver.saveUnit(Map2d.currentMap, this.x, this.y, info);
        return;
    }

    if (cleverapps.unitsSyncers) {
        cleverapps.unitsSyncers.getInstance(Map2d.currentMap.slot.slotId).save(this.x, this.y, info);
    }
};

Unit.prototype.removeFromMap = function (wasIntact) {
    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return;
    }

    let code = this.code;
    if (wasIntact) {
        code = "intact";
    } else if (this.code === "unknown") {
        if (!this._data) {
            return;
        }
        code = this._data.code;
    }

    if (cleverapps.config.name === "wordsoup") {
        WordsoupMapSaver.removeUnit(Map2d.currentMap, this.x, this.y, this);
        return;
    }

    if (cleverapps.unitsSyncers) {
        cleverapps.unitsSyncers.getInstance(Map2d.currentMap.slot.slotId).remove(this.x, this.y, code);
    }
};

Unit.prototype.showUp = function (callback) {
    this.onShowUp(callback);
};

Unit.prototype.highlightDragTarget = function () {
    this.highlight();

    if (this.view && !this.view.draggableArrow) {
        this.view.onHighlightDragTarget();
    }
};

Unit.prototype.unhighlightDragTarget = function () {
    this.unhighlight();

    if (this.view) {
        this.view.onUnhighlightDragTarget();
    }
};

Unit.prototype.pointToUnit = function () {
    if (this.view) {
        this.view.onPointToUnit();
    }
};

Unit.prototype.destructor = function () {
    this.destructed = true;

    if (this.pointsHandler) {
        this.pointsHandler.clear();
        this.pointsHandler = undefined;
    }

    this.clearSqueeze();
    this.components.forEach((component) => {
        component.destructor && component.destructor();
    });

    this.light && this.light.destructor();
    this.someUnitRemovedHandler && this.someUnitRemovedHandler.clear();

    this.removeView();
};

Unit.prototype.clearSqueeze = function () {
    clearTimeout(this.squeezeTimeout);
    this.squeezeTimeout = undefined;
};

Unit.prototype.isLockedUnit = function () {
    const lock = this.findComponent(LockedComponent);
    return lock && lock.isLockActive();
};

Unit.prototype.getKey = function () {
    return Unit.GetKey(this);
};

Unit.prototype.findComponent = function (Component) {
    for (let i = 0; i < this.components.length; i++) {
        if (this.components[i] instanceof Component) {
            return this.components[i];
        }
    }
};

Unit.prototype.setCustomerMark = function (customerMark) {
    if (!!customerMark === !!this.customerMark) {
        return;
    }

    this.customerMark = customerMark;

    this.onUpdateCustomerMark();
};

Unit.prototype.setPrizes = function (prizes, exp, silent) {
    if (cleverapps.config.editorMode) {
        return;
    }

    const prizesCount = this.prizesCount;

    prizes = cleverapps.clone(prizes, true);

    if (prizes && prizes.resource) {
        prizes = [prizes];
    }

    if (prizes && prizes.length) {
        prizes.sort((a, b) => a.resource && b.resource && (a.resource.localeCompare(b.resource) || b.amount - a.amount)
                || Boolean(b.resource) - Boolean(a.resource)
                || a.ingredient && b.ingredient && (a.ingredient.localeCompare(b.ingredient) || b.amount - a.amount)
                || Boolean(b.ingredient) - Boolean(a.ingredient));

        if (prizesCount) {
            prizes = prizes.slice(Math.max(0, prizes.length - prizesCount));
        }
    }

    this.setPrizeWarning(false);

    if (!prizes || prizes.length === 0) {
        this.prizes = undefined;
        this.prizesCount = undefined;
        this.prizesExp = undefined;
    } else {
        this.prizes = prizes;
        this.prizesCount = prizes.length;
        this.prizesExp = exp;
    }
    if (!silent) {
        this.onPrizeChanged();
    }
    this.save();
};

Unit.prototype.setPrizeWarning = function (enable) {
    if (enable) {
        this.prizeWarning = true;

        if (!this.someUnitRemovedHandler) {
            this.someUnitRemovedHandler = Map2d.currentMap.once("onUnitRemoved", () => {
                this.prizeWarning = undefined;
                this.onPrizeChanged();
                delete this.someUnitRemovedHandler;
            });
        }
    } else {
        this.prizeWarning = undefined;

        if (this.someUnitRemovedHandler) {
            this.someUnitRemovedHandler.clear();
            delete this.someUnitRemovedHandler;
        }
    }
};

Unit.prototype.takePrizes = function (options) {
    options = options || {};
    if (!this.prizes) {
        return false;
    }

    this.onTakePrizes();

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];
        if (component.handlePrizes && component.handlePrizes()) {
            return true;
        }
    }

    if (this.prizes.sprite) {
        this.prizes = undefined;
        this.onPrizeChanged();
        return false;
    }

    let expDelay = 0;

    if (this.prizes.length) {
        const resources = {};
        let ingredients = [];
        const units = [];
        let remains = [];

        this.prizes.forEach((prize) => {
            if (prize.resource) {
                resources[prize.resource] = prize.amount;
            } else if (prize.ingredient) {
                ingredients.push(prize);
            } else {
                units.push({ code: prize.code, stage: prize.stage, lock: prize.lock });
            }
        });
        if (!Unit.isConfigEmpty(resources)) {
            const rewards = new RewardsList(resources, { event: cleverapps.EVENTS.EARN.OTHER });
            if (rewards.listRewards().length) {
                rewards.receiveRewards();
                rewards.collectRewardsAnimation(this, { withoutDelta: true, rewardsInterval: (cleverapps.skins.getSlot("useLongJumpAnimation") ? 300 : 500) * Map2d.animationsTimeScale() });
            }
        }

        ingredients = ingredients.filter((prize) => {
            if (Map2dLocation.currentLocation.harvested.isFull() && !options.force) {
                Map2dLocation.currentLocation.harvested.needsToShowTip();
                remains.push(prize);
                return false;
            }

            Map2dLocation.currentLocation.harvested.add(prize.ingredient, prize.amount, true);
            return true;
        });

        if (ingredients.length) {
            this.onCollectIngredients(ingredients);
        }

        remains = remains.concat(Map2dLocation.currentLocation.spawn(units, this, {
            effect: options.effect,
            radius: Map2d.RADIUS_SMALL,
            spawnSource: this.code
        }));

        if (remains.length > 0) {
            this.prizesCount = remains.length;
            this.prizes = remains;

            this.setPrizeWarning(true);

            this.save();
            this.onPrizeChanged();
            this.onPrizeNotHarvested();
        } else {
            expDelay = (cleverapps.skins.getSlot("useLongJumpAnimation") ? 200 : units.length * 100 + 500) * Map2d.animationsTimeScale();

            this.prizesCount = undefined;
            this.prizes = undefined;

            this.setPrizeWarning(false);

            this.save();
            this.onPrizeChanged();
            this.onPrizeHarvested();
            this.onNeedToBeRemoved();

            const data = { affected: this };
            Map2d.mapEvent(Map2d.HARVEST, data);
            cleverapps.tutorial.trigger(Map2d.HARVEST, data);

            Map2d.mapEvent(Map2d.PRIZE_HARVESTED, { affected: this, prizes: units });
        }
    }

    if (!this.prizes && this.prizesExp && !cleverapps.gameModes.skipExpPrize) {
        Map2dLocation.currentLocation.addReward("exp", this.prizesExp, this, {
            delay: expDelay,
            timeScale: Map2d.animationsTimeScale()
        });
        this.prizesExp = undefined;
    }

    return true;
};

Unit.prototype.onTakePrizes = function () {
    this.squeeze();
};

Unit.prototype.isGrounded = function () {
    return this.findComponent(Grounded) !== undefined;
};

Unit.prototype.isMultiCell = function () {
    return this.findComponent(MultiCell) !== undefined;
};

Unit.prototype.isUpgradable = function () {
    return this.findComponent(Upgradable);
};

Unit.prototype.isFeedable = function () {
    return this.findComponent(Feedable) !== undefined;
};

Unit.prototype.isMultiCellBody = function () {
    return this.code === "multiCellBody";
};

Unit.prototype.isStopsFog = function () {
    return Boolean(this.getData().stopsfog);
};

Unit.prototype.isImpassable = function () {
    return Boolean(this.getData().impassable);
};

Unit.prototype.canShareBodyCell = function (otherUnit) {
    if (!this.isMultiCellBody() || !this.head.isGrounded() && !this.head.isStopsFog()) {
        return false;
    }

    otherUnit = otherUnit.head || otherUnit;
    return otherUnit.isGrounded() || otherUnit.isStopsFog() || otherUnit.code === "unknown";
};

Unit.prototype.shareBodyCell = function (otherUnit) {
    const unit = this.head;

    this.x = undefined;
    this.y = undefined;

    unit.sharedWith = unit.sharedWith || [];
    if (unit.sharedWith.indexOf(otherUnit) === -1) {
        unit.sharedWith.push(otherUnit);
    }

    otherUnit.sharedWith = otherUnit.sharedWith || [];
    if (otherUnit.sharedWith.indexOf(unit) === -1) {
        otherUnit.sharedWith.push(unit);
    }
};

Unit.prototype.restoreSharedBodyCells = function () {
    if (this.sharedWith) {
        this.sharedWith.forEach(function (unit) {
            const index = unit.sharedWith.indexOf(this);
            if (index !== -1) {
                unit.sharedWith.splice(index, 1);
            } else {
                cleverapps.throwAsync("Unit not found in shared cell");
            }

            const multicell = unit.findComponent(MultiCell);
            if (multicell) {
                multicell.restore();
            }
        }, this);
        this.sharedWith = undefined;
    }
};

Unit.prototype.getActionInfo = function () {
    let info;

    if (!Buildable.IsBuilt(this)) {
        return this.findComponent(Buildable).getActionInfo();
    }

    if (!Creatable.IsCreated(this)) {
        return this.findComponent(Creatable).getActionInfo();
    }

    for (let i = this.components.length - 1; i >= 0; --i) {
        const component = this.components[i];

        if (component.getActionInfo) {
            info = component.getActionInfo();
        }

        if (info === false) {
            return;
        }

        if (info) {
            break;
        }
    }

    if (this.isSellable()) {
        info = info || {};
        info.title = info.title || cleverapps.unitsLibrary.getUnitName(this);
        if (cleverapps.gameLevel.getLevel() >= Unit.MINIMAL_SELL_LEVEL
            && (cleverapps.meta.getSelectedLocation().locationConfig.isMain || Map2d.currentMap.fogs.isOpened(Unit.MINIMAL_SELL_FOG) || cleverapps.meta.selectedLocationId() === "collections")) {
            info.buttons = info.buttons || {};
            info.buttons.sell = { unit: this };
        }
    }

    const data = this.getData();

    if (data.rarity) {
        info = info || {};
        info.rarity = data.rarity;
    }

    if (data.unitsLibrary && !info.windowParameters) {
        info = info || {};
        info.windowParameters = {
            unit: this,
            unitsLibrary: true
        };
    }

    const upgradable = this.findComponent(Upgradable);
    if (upgradable && upgradable.level) {
        info = info || {};
        info.upgradableLevel = upgradable.level;
    }

    if (this.code === "unknown") {
        info = {};
        info.description = Messages.get("Units.unknown.description");

        if (this._data) {
            info.buttons = {};
            info.buttons.sell = { unit: this };

            if (cleverapps.config.debugMode) {
                info.title = `${this._data.code} stage${this._data.stage}`;
            }
        }
    }

    return info;
};

Unit.prototype.isSellable = function () {
    const collectible = this.findComponent(Collectible);
    if (collectible && collectible.canRemoved()) {
        return true;
    }

    const family = Families[this.code];

    switch (this.code) {
        case "coins": case "rubies": case "drgrowing":
            return this.stage === 0;
        case "worker": case "drmagicplant": case "seamagicplant":
            return this.stage < family.units.length - 1;
        case "magicplant":
            return this.stage < family.units.length - 2;
        case "crystal": case "dr2wheat": case "dr2coal": case "dr2barrel":
            return true;
    }

    switch (family.type) {
        case "resource":
            return this.stage < family.units.length - 2 && this.isBuilt();
        case "fruit": case "seafruit": case "clfruit": case "drfruit":
            return this.stage < 3;
        case "source":
            return !this.findComponent(Mineable);
        case "drresource": case "searesource":
            return this.stage < family.units.length - 1 && this.isBuilt();
        case "drgift": case "seagift": case "clpet": case "clpetrare": case "clpetlegend":
        case "drproduct0": case "drproduct1": case "drproduct2":
            return true;
    }

    return false;
};

Unit.prototype.isMovable = function (draggingUnit) {
    if (this.isMultiCellBody()) {
        return this.head.isMovable();
    }

    if (cleverapps.config.editorMode || cleverapps.config.demoMode) {
        return true;
    }

    if (this.movable === false || this.getData().stopsfog) {
        return false;
    }

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];
        if (!component.isMovable(draggingUnit)) {
            return false;
        }
    }

    return true;
};

Unit.prototype.isBlockedCell = function (x, y) {
    const map = Map2d.currentMap;
    if (!map.isGround(x, y)) {
        return true;
    }

    const unit = map.getUnit(x, y);
    if (unit && !unit.isMovable(this)) {
        return true;
    }

    if (unit && unit.head && unit.head !== this) {
        return true;
    }

    if (unit && unit.isMultiCell() && unit !== this) {
        return true;
    }

    if (map.isOccupiedByFog(x, y)) {
        return true;
    }

    return false;
};

Unit.prototype.isIntact = function (data) {
    const locationId = cleverapps.meta.selectedLocationId();

    if (!Unit.INTACT_ENABLED || this.code === "unknown" || Unit.NOT_INTACT_COMPATIBLE[locationId] && Unit.NOT_INTACT_COMPATIBLE[locationId].indexOf(cleverapps.config.name) !== -1) {
        return false;
    }

    const fakeUnit = Map2d.currentMap.fogs.getFakeUnit(this.x, this.y);

    return this.equals(fakeUnit) && Object.keys(data).every((key) => key === "code" || key === "stage" || data[key] === undefined);
};

Unit.prototype.canMoveTo = function (x, y) {
    if (!Unit.MULTY_CELL_BODY_OCCUPIED_CELL) {
        return !this.isBlockedCell(x, y);
    }

    return this.getShape().every(function (part) {
        return !this.isBlockedCell(x + part.x, y + part.y);
    }, this);
};

Unit.prototype.handleClick = function () {
    cleverapps.userStatus.reportUserAction();

    if (this.points) {
        this.claimPoints();
        Map2d.mapEvent(Map2d.CLICK_UNIT, { affected: this });
        return true;
    }

    const worker = Map2d.currentMap.workers && Map2d.currentMap.workers.findAssigned(this);
    if (worker !== undefined) {
        if (Unit.CalcSpeedUPPrice(worker.getTimeLeft()) > 0 && !worker.speedupInProgress) {
            cleverapps.focusManager.display({
                focus: "SpeedUp",
                action: function (f) {
                    new SpeedUpWindow(worker);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
        Map2d.mapEvent(Map2d.CLICK_UNIT, { affected: this });
        return true;
    }

    if (this.takePrizes()) {
        this.playClickSound();
        Map2d.mapEvent(Map2d.CLICK_UNIT, { affected: this });
        return true;
    }

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];

        if (component instanceof LockedComponent && component.handleClick()) {
            break;
        } else if (component.handleClick && component.handleClick()) {
            Map2d.mapEvent(Map2d.CLICK_UNIT, { affected: this });
            return true;
        }
    }

    return false;
};

Unit.prototype.distanceTo = function (target) {
    return Math.abs(this.x - target.x) + Math.abs(this.y - target.y);
};

Unit.prototype.isMergeable = function (otherUnit, canBeCrystal) {
    if (otherUnit.isDragged()) {
        return false;
    }

    if (this.getData().stopsfog || otherUnit.getData().stopsfog) {
        return false;
    }

    if (this.isUnmergeable() || otherUnit.isUnmergeable()) {
        return false;
    }

    if (this.isLockedUnit() || otherUnit.isLockedUnit()) {
        return false;
    }

    if (!this.isBuilt() || !otherUnit.isBuilt()) {
        return false;
    }

    if (otherUnit.isLast() && otherUnit.getData().mergeUnit === undefined) {
        return false;
    }

    if (!CupComponent.CanMerge(this, otherUnit)) {
        return false;
    }

    if (this.isLockedByTutorial() || otherUnit.isLockedByTutorial()) {
        return false;
    }

    if (canBeCrystal && this.isMagicCrystal() && !Unit.DISABLED_MERGABLE_UNITS_FOR_CRYSTAL.includes(otherUnit.code)) {
        return true;
    }

    return otherUnit.code === this.code && otherUnit.stage === this.stage;
};

Unit.prototype.isBuilt = function () {
    return Buildable.IsBuilt(this) && Creatable.IsCreated(this);
};

Unit.prototype.isMagicCrystal = function () {
    return this.code === "crystal" && this.isLast();
};

Unit.prototype.getMergeUnit = function () {
    if (this.getData().mergeUnit) {
        return this.getData().mergeUnit;
    }

    const nextStage = this.stage + 1;

    if (!Families[this.code].units[nextStage]) {
        return undefined;
    }

    return {
        code: this.code,
        stage: nextStage
    };
};

Unit.prototype.setPosition = function (x, y) {
    if (!this.isLifted()) {
        if (cleverapps.config.debugMode) {
            console.log(this);
            throw "setPosition for already positioned unit";
        }
    }

    const map = Map2d.currentMap;
    const multicell = this.findComponent(MultiCell);

    this.getShape().forEach(function (part, i) {
        if (!Unit.MULTY_CELL_BODY_OCCUPIED_CELL && (part.x !== 0 || part.y !== 0)) {
            return;
        }

        const unit = (part.x === 0 && part.y === 0) ? this : multicell.bodyUnits[i];

        unit.x = x + part.x;
        unit.y = y + part.y;

        const wasUnit = map.getUnit(unit.x, unit.y);
        const singleton = wasUnit && wasUnit.findComponent(Singleton);

        if (wasUnit) {
            if (unit.canShareBodyCell(wasUnit)) {
                unit.shareBodyCell(wasUnit);
                return;
            }

            if (wasUnit.canShareBodyCell(unit)) {
                wasUnit.shareBodyCell(unit);
            } else if (singleton) {
                singleton.kickOut();
            }
        }

        map.add(Map2d.LAYER_UNITS, unit.x, unit.y, unit);
    }, this);

    this.save();
};

Unit.prototype.isLifted = function () {
    return this.x === undefined || this.y === undefined;
};

Unit.prototype.isDragged = function () {
    return this.dragX !== undefined || this.dragY !== undefined;
};

Unit.prototype.remove = function (silent) {
    this.unhighlight();

    for (let i = 0; i < this.components.length; i++) {
        const component = this.components[i];
        component.handleRemove && component.handleRemove();
    }

    this.restoreSharedBodyCells();

    if (!silent) {
        this.onRemove();
    }

    Map2d.currentMap.onUnitRemoved(this);

    this.destructor();
};

Unit.prototype.sell = function () {
    const price = Unit.CalcSellPrice(this);
    if (price) {
        Map2dLocation.currentLocation.addReward(Unit.CalcSellCurrency(this), price, this.onGetView(), {
            withoutDelta: true
        });
        cleverapps.metrics.logEvent(cleverapps.EVENTS.UNITS_SOLD, { value: price });
    }

    this.onDestruction();
    this.remove(true);
};

Unit.prototype.liftUnitFromMap = function () {
    if (this.isLifted()) {
        if (cleverapps.config.debugMode) {
            console.log(this);
            throw "Lift twice!";
        }
        return;
    }

    let wasIntact = false;
    if (this.intact) {
        wasIntact = true;
        this.intact = undefined;
    }

    this.removeFromMap(wasIntact);

    const map = Map2d.currentMap;

    const x = this.x;
    const y = this.y;
    this.getShape().forEach(function (part) {
        if (!Unit.MULTY_CELL_BODY_OCCUPIED_CELL && (part.x !== 0 || part.y !== 0)) {
            return;
        }

        const unit = map.getUnit(x + part.x, y + part.y);
        if (!unit) {
            let message = `Unit undefined - ${JSON.stringify({
                code: this.code, stage: this.stage, x, y, partX: part.x, partY: part.y
            })}`;
            message += ` stack - ${new Error().stack}`;
            message += ` removeStack - ${this.removeStack}`;
            if (part.x === 0 && part.y === 0) {
                throw message;
            } else {
                cleverapps.throwAsync(message);
                return;
            }
        }

        delete unit.x;
        delete unit.y;

        if (unit !== this && unit.head !== this) {
            if (cleverapps.config.debugMode) {
                console.log(this, unit);
                throw "Error while liftUnitFromMap!";
            }
        }

        map.remove(Map2d.LAYER_UNITS, x + part.x, y + part.y);
    }, this);
};

Unit.prototype.seedRandom = function (seed) {
    seed = seed || 0;
    if (this.isLifted()) {
        if (Map2d.currentMap.currentLoadingUnitPosition) {
            seed += Map2d.currentMap.currentLoadingUnitPosition.x * 1000 + Map2d.currentMap.currentLoadingUnitPosition.y;
        }
    } else {
        seed += this.x * 1000 + this.y;
    }
    return PseudoRandom.GET().seed(connector.platform.getUserID() + seed);
};

Unit.prototype.getShape = function () {
    return this.shape;
};

Unit.prototype.highlight = function (options) {
    options = options || {};

    this.unhighlight();

    this.light = new Highlight(this.x, this.y, {
        isErrorLight: options.isErrorLight,
        unit: this,
        drag: options.drag
    });
    if (options.drag) {
        Map2d.currentMap.onAnimationsAdd(this.light);
        this.light.move(this.x, this.y, true);
    } else {
        Map2d.currentMap.onAdd(Map2d.LAYER_UNITS, this.light.x, this.light.y, this.light);
    }

    if (options.duration) {
        this.light.schedule(this.unhighlight.bind(this), options.duration);
    }

    this.components.forEach((component) => {
        if (component.onHighlight) {
            component.onHighlight();
        }
    });
};

Unit.prototype.unhighlight = function () {
    if (this.light) {
        this.light.remove();
        delete this.light;
    }
    this.components.forEach((component) => {
        if (component.onUnhighlight) {
            component.onUnhighlight();
        }
    });
};

Unit.prototype.unhighlightMerge = function () {
    if (!this.clusters) {
        return;
    }

    this.onStopAnimateMerge();
    cleverapps.centerHint.finishCenterHint();

    this.clusters.forEach((affected) => {
        affected.forEach((p) => {
            const unit = Map2d.currentMap.getUnit(p.x, p.y);
            if (unit) {
                unit.unhighlight();
                unit.onStopAnimateMerge(p);
            }
        });
    });

    this.clusters = undefined;
};

Unit.prototype.highlightMerge = function (clusters) {
    this.clusters = clusters;

    this.onStartAnimateMerge(this);

    clusters.forEach((affected) => {
        const target = affected[0];
        affected.forEach((p) => {
            const unit = Map2d.currentMap.getUnit(p.x, p.y);
            unit.highlight();

            if (cleverapps.gameModes.lightUpOnHoveredUnit && unit.distanceTo(target) === 0 && unit !== this) {
                unit.light.up();
            }

            unit.onStartAnimateMerge(target);
        });
    });
};

Unit.prototype.didMerged = function (parentUnit, index) {
    if (Unit.Equals(parentUnit, this)) {
        const rewards = this.isBuilt() ? this.getCreatePrize() : {};

        const stars = cleverapps.clanCup && cleverapps.clanCup.isRunning() && Unit.CalcCupStars(this);
        if (stars) {
            const icon = cleverapps.sideBar.getIconByClassName(ClansCupIcon);
            if (icon && !icon.disabled) {
                rewards.cup = {
                    type: CupsConfig.TYPE_CLAN,
                    amount: stars
                };
            }
        }

        if (!Unit.isConfigEmpty(rewards)) {
            const rewardList = new RewardsList(rewards, {
                event: cleverapps.EVENTS.EARN.OTHER
            });
            rewardList.receiveRewards();
            rewardList.collectRewardsAnimation(this, {
                delay: 700
            });
        }
    }

    this.onDidMerged(parentUnit, index);
};

Unit.prototype.handleDragStart = function () {
    if (this.isLockedByTutorial() || !this.isMovable()) {
        return false;
    }

    if (this.points) {
        this.claimPoints();
        return false;
    }

    cleverapps.userStatus.reportUserAction();
    Map2d.currentMap.setDragging(this);
    this.highlight({ drag: true });
    this.onMarkDragging();

    const draggable = this.findComponent(Draggable);
    if (draggable) {
        draggable.handleDragStart();
    }

    const pulsing = this.findComponent(Pulsing);
    if (pulsing) {
        pulsing.setDragging(true);
    }

    this.dragX = this.x;
    this.dragY = this.y;

    return true;
};

Unit.prototype.handleDragMove = function (rawX, rawY) {
    let x = Math.round(rawX),
        y = Math.round(rawY);

    if (this.isMultiCell()) {
        const size = this.findComponent(MultiCell).getSize();

        x = Math.round(rawX - size.width / 2);
        y = Math.round(rawY - size.height / 2);
    }

    const cellsInRadius = [{ x, y }];

    const threshold = Unit.NEXT_CELL_CHECK_THRESHOLD;

    const diffX = rawX - x;
    if (Math.abs(diffX) > threshold) {
        cellsInRadius.push(diffX > 0 ? { x: x + 1, y } : { x: x - 1, y });
    }

    const diffY = rawY - y;
    if (Math.abs(diffY) > threshold) {
        cellsInRadius.push(diffY > 0 ? { x, y: y + 1 } : { x, y: y - 1 });
    }

    if (Math.abs(diffX) > threshold && Math.abs(diffY) > threshold) {
        const cellX = diffX > 0 ? x + 1 : x - 1;
        const cellY = diffY > 0 ? y + 1 : y - 1;

        cellsInRadius.push({ x: cellX, y: cellY });
    }

    if (cleverapps.gameModes.automerge) {
        AutomergeHelper.handleDragMove(this, x, y);
        return;
    }

    const mergeComponent = this.findComponent(MergeComponent);
    if (mergeComponent && mergeComponent.handleDragMove(x, y, cellsInRadius)) {
        return;
    }

    this.dragX = x;
    this.dragY = y;

    const draggable = this.findComponent(Draggable);
    if (draggable && draggable.handleDragMove(this.dragX, this.dragY)) {
        return;
    }

    if (this.light) {
        this.light.show();
        this.light.move(this.dragX, this.dragY);
    }

    if (!this.light || this.light.error) {
        this.onMarkError();
    } else {
        this.onMarkDragging();
    }
};

Unit.prototype.handleDragEnd = function (cancelled) {
    const error = !this.light || this.light.error;

    this.unhighlight();

    const pulsing = this.findComponent(Pulsing);
    if (pulsing) {
        pulsing.setDragging(false);
    }

    cleverapps.userStatus.reportUserAction();
    Map2d.currentMap.setDragging(undefined);
    cleverapps.centerHint.finishCenterHint();

    const draggable = this.findComponent(Draggable);
    if (draggable && draggable.handleDragEnd(this.dragX, this.dragY)) {
        this.dragX = undefined;
        this.dragY = undefined;
        return;
    }

    if (cancelled || error || this.x === this.dragX && this.y === this.dragY) {
        this.dragX = undefined;
        this.dragY = undefined;
        this.onMove();
        return;
    }

    const mergeComponent = this.findComponent(MergeComponent);
    if (mergeComponent && mergeComponent.handleDragEnd(this.dragX, this.dragY)) {
        return;
    }

    if (cleverapps.tutorial.isInputLocked()) {
        const occupied = Map2d.currentMap.getUnit(this.dragX, this.dragY);
        if (!occupied || occupied.isLockedByTutorial()) {
            cleverapps.tutorial.reportWrong();
            this.dragX = undefined;
            this.dragY = undefined;
            this.onMove();
            return;
        }
    }

    this.move(this.dragX, this.dragY, true);

    this.dragX = undefined;
    this.dragY = undefined;

    if (cleverapps.gameModes.automerge) {
        AutomergeHelper.handleDragEnd(this, this.x, this.y);
    }
};

Unit.prototype.isLockedByTutorial = function (options) {
    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive()) {
        return !Map2dLocation.currentLocation.tutorial.checkConditions({ unit: this, ...options }) && !Map2dLocation.currentLocation.tutorial.checkConditions({ preferCell: this, ...options });
    }

    if (cleverapps.tutorial.isActive()) {
        return !cleverapps.tutorial.checkConditions({ unit: this, ...options }) && !cleverapps.tutorial.checkConditions({ preferCell: this, ...options });
    }
};

Unit.prototype.getCreatePrize = function () {
    if (cleverapps.gameModes.skipUnitCreatePrize) {
        return {};
    }

    const rewards = {};
    const createPrize = this.getData().createPrize || {};

    if (createPrize.soft) {
        rewards.soft = createPrize.soft;
    }

    if (createPrize.exp) {
        rewards.exp = createPrize.exp;
    }
    return rewards;
};

Unit.prototype.move = function (x, y, isNewPlace) {
    const map = Map2d.currentMap;

    let occupiedList = [];

    this.getShape().forEach(function (part) {
        if (!Unit.MULTY_CELL_BODY_OCCUPIED_CELL && (part.x !== 0 || part.y !== 0)) {
            return;
        }

        let occupied = map.getUnit(x + part.x, y + part.y);
        if (!occupied) {
            return;
        }
        if (occupied.head) {
            occupied = occupied.head;
        }
        if (occupied !== this) {
            occupiedList.push(occupied);
        }
    }, this);

    occupiedList = cleverapps.unique(occupiedList, Unit.GetPositionKey);

    if (!this.isLifted()) {
        this.liftUnitFromMap();
    }

    occupiedList.forEach((occupied) => {
        occupied.liftUnitFromMap();
    });

    this.setPosition(x, y);
    this.unhighlight();
    this.onMove({
        isNewPlace
    });

    occupiedList.forEach((occupied) => {
        const singleton = occupied.findComponent(Singleton);
        if (singleton) {
            singleton.moveFromPoint(x, y);
        }
    });

    if (Map2d.currentMap.workers.findAssigned(this)) {
        Map2d.currentMap.workers.save();
    }
};

Unit.prototype.suspendBuilding = function (timeSpent) {
    const buildable = this.findComponent(Buildable);
    if (buildable) {
        buildable.buildingSuspend(timeSpent);
        this.save();
    }
};

Unit.prototype.completeBuilding = function () {
    const location = cleverapps.meta.getSelectedLocation();
    if (location.families && !location.families[this.code]) {
        cleverapps.throwAsync(`Built unit from other world : ${JSON.stringify({
            unit: Unit.GetKey(this),
            position: Unit.GetPositionKey(this)
        })}`);
    }

    [Buildable, Fruit, Upgradable, Pulsing].forEach((Component) => {
        const component = this.findComponent(Component);
        if (component) {
            component.buildingComplete();
        }
    });

    const rewards = this.getCreatePrize();
    if (!Unit.isConfigEmpty(rewards)) {
        const rewardList = new RewardsList(rewards, { event: cleverapps.EVENTS.EARN.OTHER });
        rewardList.receiveRewards();
        rewardList.collectRewardsAnimation(this, {
            delay: 700
        });
    }

    const data = {
        affected: this,
        time: cleverapps.parseInterval(this.getData().creatable ? "0 seconds" : this.getData().buildable)
    };
    Map2d.mapEvent(Map2d.BUILD, data);
    cleverapps.tutorial.trigger(Map2d.BUILD, data);

    Map2d.currentMap.onUnitFresh(this);
    Map2d.currentMap.onUnitAvailable(this);

    const mission = cleverapps.missionManager.findLocalPass();
    if (mission && Mission.TYPE_BUILDPASS === mission.type) {
        if (!mission.logic.isAllTasksCompleted()) {
            this.setPoints(PassMissionLogic.BuildableUnitPoints(this));
        }
    }

    cleverapps.travelBook.updateBuilt();

    this.save();
};

Unit.prototype.getFamily = function () {
    return Families[this.code];
};

Unit.prototype.isLast = function () {
    const lastStage = this.getFamily().units.length - 1;
    return lastStage === this.stage;
};

Unit.prototype.isCastle = function () {
    return this.getType() === "resource" && this.isLast();
};

Unit.prototype.isValuable = function () {
    return this.getType() === "valuables" && !this.isGrounded();
};

Unit.getPreviousStagesTargets = function (code, stage) {
    return cleverapps.arrayFill(stage).map((value, index) => ({ code, stage: index }));
};

Unit.getAllStagesTargets = function (code) {
    return Families[code] ? Unit.getPreviousStagesTargets(code, Families[code].units.length) : [];
};

Unit.prototype.setPoints = function (amount, destructedMap) {
    if (destructedMap) {
        const otherUnit = destructedMap.getUnit(this.x, this.y);

        // eslint-disable-next-line max-len
        cleverapps.throwAsync(`react to mission event after map destruction ${this.code} ${this.stage} ${amount} ${this.destructed} ${!!this.pointsHandler} ${this.x} ${this.y} ${otherUnit === this} ${otherUnit && otherUnit.code} ${otherUnit && otherUnit.stage}`);
        return;
    }

    this.points = amount;
    this.save();

    if (this.points) {
        if (!this.pointsHandler) {
            this.pointsHandler = cleverapps.missionManager.on("erasePassPoints", (destructedMap) => this.setPoints(0, destructedMap));
        }
    } else if (this.pointsHandler) {
        this.pointsHandler.clear();
        this.pointsHandler = undefined;
    }

    if (amount) {
        this.onShowPoints();
    } else {
        this.onHidePoints();
    }
};

Unit.prototype.claimPoints = function () {
    if (!this.points) {
        return;
    }

    const points = this.points;
    delete this.points;

    this.save();

    this.pointsHandler.clear();
    this.pointsHandler = undefined;

    const mission = cleverapps.missionManager.findLocalPass();
    if (!mission) {
        this.onHidePoints();
        return;
    }

    const reward = new Reward("mission", {
        missionType: mission.type,
        amount: points
    });
    reward.receiveReward();

    this.onClaimPoints(() => {
        reward.onAnimationFinished();
    });
};

Unit.prototype.squeeze = function (callback) {
    if (this.getData().squeezable !== false) {
        this.onSqueeze();
    }

    if (callback) {
        this.clearSqueeze();
        this.squeezeTimeout = setTimeout(callback, Unit.SQUEEZE_DURATION);
    }
};

Unit.prototype.getDnDAccepted = function (targetUnit) {
    this.onGetDnDAccepted(targetUnit);
    this.remove(true);
};

Unit.prototype.animateOutOfSync = function () {
    if (cleverapps.config.name === "wondermerge"
        && Families[this.code].type === "resource"
        && this.getData().buildable) {
        return true;
    }

    if (Families[this.code].type === "drhero" && this.stage === 0) {
        return true;
    }

    return false;
};

Unit.prototype.showAdditionalViews = function () {
    if (this.additionalViewsHidden) {
        this.additionalViewsHidden = false;

        if (this.view && this.view.showAdditionalViews) {
            this.view.showAdditionalViews();
        }
    }
};

Unit.prototype.hideAdditionalViews = function () {
    if (!this.additionalViewsHidden) {
        this.additionalViewsHidden = true;

        if (this.view && this.view.hideAdditionalViews) {
            this.view.hideAdditionalViews();
        }
    }
};

Unit.prototype.outline = function (restore) {
    if (this.view && this.view.outline) {
        this.view.outline(restore);
    }
};

Unit.prototype.clearAnimations = function () {
    this.components.forEach((component) => {
        if (component.clearAnimations) {
            component.clearAnimations();
        }
    });
};

Unit.prototype.equals = function (other) {
    return Unit.Equals(this, other);
};

Unit.prototype.findAcceptorComponent = function (targets, options) {
    targets = cleverapps.toArray(targets);

    for (let i = 0; i < this.components.length; ++i) {
        const component = this.components[i];
        if (component.canAcceptDraggable && targets.some((target) => component.canAcceptDraggable(target, options))) {
            return component;
        }
    }
};

Unit.prototype.setBlock = function (blocked) {
    this.blocked = Boolean(blocked);
};

Unit.prototype.isBlocked = function () {
    return this.blocked;
};

Unit.prototype.getConsoleInfo = function () {
    return {
        code: this.code,
        stage: this.stage,
        x: this.x,
        y: this.y,
        name: cleverapps.unitsLibrary.getUnitName(this.head || this)
    };
};

Unit.prototype.canSmile = function () {
    if (this.isDragged()) {
        return false;
    }

    if (this.isGrounded()) {
        return this.findComponent(Grounded).canSmile();
    }

    const unitView = this.onGetView();
    if (!unitView) {
        return false;
    }

    return unitView.canSmile();
};

Unit.prototype.smile = function () {
    if (this.isGrounded()) {
        this.findComponent(Grounded).smile();
    } else if (this.view) {
        this.view.smile();
    }
};

Unit.prototype.canHideTile = function () {
    if (this.view && this.view.canHideTile && !this.view.canHideTile()) {
        return false;
    }
    return true;
};

Unit.prototype.onShowTile = function () {
    for (const component of this.components) {
        if (component.onShowTile) {
            component.onShowTile();
        }
    }
};

Unit.prototype.onHideTile = function () {
    for (const component of this.components) {
        if (component.onHideTile) {
            component.onHideTile();
        }
    }
};

Unit.Equals = function (unit1, unit2) {
    return unit1 && unit2 && unit1.code !== undefined && unit1.stage !== undefined
        && unit1.code === unit2.code && unit1.stage === unit2.stage;
};

Unit.SameLine = function (unit1, unit2) {
    return unit1 && unit2 && unit1.code !== undefined && unit1.code === unit2.code;
};

Unit.CalcSellCurrency = function () {
    return "soft";
};

Unit.CalcSellPrice = function (unit) {
    const price = function (stage) {
        const price = (stage + 1) * Math.sqrt(stage + 1);

        return Math.round(price);
    };

    if (!Families[unit.code]) {
        cleverapps.throwAsync(`No family for code ${unit.code}`);
        return 0;
    }

    if (unit.code === "unknown") {
        return 0;
    }

    const family = Families[unit.code];

    switch (family.type) {
        case "source": case "searesource": case "drgrowing":
        case "clpet": case "clpetrare": case "clpetlegend":
            return 0;
        case "fruit": case "seafruit": case "clfruit": case "drfruit":
            if (family.units[unit.stage].collectible) {
                return 0;
            }
            return price(unit.stage);
        case "chest": case "drchest": case "seachest": case "hlchest": case "rpchest": case "eachest": case "clchest":
            return unit.findComponent(Chest).calcSellPrice();
    }

    switch (unit.code) {
        case "worker": case "magicplant": case "crystal":
            return price(unit.stage + 1);
        case "drmagicplant": case "seamagicplant":
            return price(unit.stage - 2);
    }

    return price(unit.stage - 1);
};

Unit.CalcSpeedUPPrice = function (duration) {
    const factor = 0.7;
    return Unit.convertHardPrice(Math.max(Math.ceil((duration / 60 / 1000 - 0.5) * factor), 0));
};

Unit.convertHardPrice = function (price) {
    return price;
};

Unit.CalcCupStars = function (unit) {
    let amount = unit.stage;

    if (unit.stage >= 3) {
        amount = Math.floor(Math.pow(2.1, unit.stage - 3)) * 10;
    }

    return amount;
};

Unit.IsApplicable = function (target, unit) {
    if (Array.isArray(target)) {
        return unit && target.some((targetItem) => Unit.IsApplicable(targetItem, unit));
    }

    const type = unit.getType ? unit.getType() : unit.type;

    return !target || (target.type === undefined || target.type === type)
        && (target.code === undefined || target.code === unit.code)
        && (target.stage === undefined || target.stage === unit.stage);
};

Unit.GetKey = function (unit) {
    return `${unit.code}_${unit.stage}`;
};

Unit.GetPositionKey = function (unit) {
    return `${unit.x}_${unit.y}`;
};

Unit.GetShape = function (unit) {
    const data = unit && Families[unit.code] && Families[unit.code].units[unit.stage];
    if (!data || !data.multicell) {
        return FamiliesHelper.ShapeCell;
    }

    if (Array.isArray(data.multicell)) {
        return data.multicell;
    }

    const locationId = cleverapps.meta.selectedLocationId();
    if (data.multicell[locationId]) {
        return data.multicell[locationId];
    }

    return data.multicell.default || FamiliesHelper.ShapeCell;
};

Unit.GetComposite = function (unit) {
    const data = unit && Families[unit.code] && Families[unit.code].units[unit.stage];
    if (data && data.composite) {
        return data.composite;
    }
    return undefined;
};

Unit.GetDropType = function (code) {
    const type = Families[code] && Families[code].dropType;
    return type !== undefined ? type : FamiliesHelper.Drop.Default;
};

Unit.ParseKey = function (key) {
    key = key.split("_");

    if (key.length !== 2) {
        return;
    }

    return {
        code: key[0],
        stage: cleverapps.castType(key[1])
    };
};

Unit.ParsePositionKey = function (key) {
    key = key.split("_");
    return {
        x: parseInt(key[0]),
        y: parseInt(key[1])
    };
};

Unit.findUnit = function (units, searchUnit) {
    searchUnit = searchUnit || {};
    for (let i = 0; i < units.length; ++i) {
        const unit = units[i];
        if ((searchUnit.code === undefined || unit.code === searchUnit.code) && (searchUnit.stage === undefined || unit.stage === searchUnit.stage)) {
            return unit;
        }
    }
};

Unit.isConfigEmpty = function (rewards) {
    if (!rewards) {
        return true;
    }

    rewards = cleverapps.toArray(rewards);
    if (rewards.length === 0) {
        return true;
    }

    return rewards.some((reward) => {
        if (reward instanceof Reward) {
            return false;
        }

        const types = Object.keys(reward);
        return types.length === 0 || types.some((type) => !RewardTypes[type] || !reward[type]);
    });
};

Unit.DISABLED_CODES = cleverapps.createSet(["multiCellBody", "thirdelement", "t", "barrel", "caravanship", "islanddecoration"]);
Unit.DELETED_CODES = cleverapps.createSet([
    "seasonalspot", "hlseasonalitem", "seasonchest", "season0", "season1", "season2", "season3", "season4", "season5", "season6", "season7", "season8", "season9", "season10", "season11",
    "salecup", "saleship",
    "seajellyfishchest", "dr2wood", "dr2stone", "dr2sapphire", "dr2woodsource", "dr2stonesource", "dr2sapphiresource",
    "dr2woodchest", "dr2stonechest", "dr2sapphirechest", "dr2stonegenerator", "dr2sapphiregenerator", "dr2shopchest",
    "dr2freechest", "dr2magicplant", "dr2battlepass", "dr2growing", "dr2house", "dr2portal",
    "driron", "dryellowcrystal", "drironsource", "dryellowcrystalsource", "drironchest", "dryellowcrystalchest",
    "drirongenerator", "dryellowcrystalgenerator", "dishes",
    "xmcookie", "xmsanta", "xmsnowman", "xmdeer", "xmyeti", "xmelf", "xmtoy", "xmsocks", "xmcandy", "xmsled", "xmcastle",
    "xmtoysource", "xmsockssource", "xmcandysource", "xmsledsource", "xmcastlesource", "xmtoychest", "xmsockschest",
    "xmcandychest", "xmsledchest", "xmcastlechest", "xmshopchest", "xmfreechest", "xmshop", "xmmagicplant", "xmbattlepass",
    "xmgrowing", "xmhouse", "xmfactory", "xmrudolf", "xmgiftball", "xmgiftdoll", "xmgiftbear", "xmhunter", "xmgnome", "xmplane",
    "xmorder", "xmlamberjack", "xmtoygenerator", "xmsocksgenerator", "xmcandygenerator", "xmsledgenerator", "xmcastlegenerator",
    "xmpack", "xmbread", "xmigloo", "xmbreadsource", "xmigloosource", "xmbreadchest", "xmigloochest", "xmbreadgenerator",
    "xmigloogenerator", "xmbridge", "xmproducertrash", "xmcustomerbridge1", "xmcustomerbridge2", "xmcustomerbridge3",
    "xmproduct0a", "xmproduct0b", "xmproduct1b", "xmproduct1a", "xmproduct2a", "xmproducer0a", "xmproducer1a", "xmproducer1b",
    "xmproducer2a", "xmproducer2b", "xmcustomermain0", "xmcustomermain1", "xmcustomermain2", "xmcustomermain3",
    "xmcustomermain4", "xmcustomermain5",
    "chbamboo", "chbamboosource", "chcastle", "chcastlesource", "chdragongreen", "chdragonpurple", "chdragonrainbow",
    "chdragonred", "chdragonyellow", "chfeathers", "chfeatherssource", "chfreechest", "chnarrator", "chsapphire",
    "chsapphiresource", "chshopchest", "chsourcegenerator", "chthrone", "chshop", "sea2crab", "sea2fishes", "sea2shark",
    "sea2octopus", "sea2jellyfish", "sea2lochness", "sea2turtle", "sea2shrimps",
    "sea2crabsource", "sea2fishessource", "sea2sharksource", "sea2jellyfishsource", "sea2lochnesssource",
    "sea2turtlesource", "sea2shrimpssource", "sea2octopussource", "sea2fishesgenerator", "sea2sharkgenerator",
    "sea2octopusgenerator", "sea2jellyfishgenerator", "sea2crabgenerator", "sea2lochnessgenerator",
    "sea2turtlegenerator", "sea2shrimpsgenerator", "sea2shopchest", "sea2freechest", "sea2sack", "sea2crabchest",
    "sea2fisheschest", "sea2sharkchest", "sea2octopuschest", "sea2jellyfishchest", "sea2lochnesschest",
    "sea2turtlechest", "sea2shrimpschest", "sea2shop", "sea2magicplant", "sea2portal", "sea2house", "sea2snail",
    "sea2tournament", "sea2strawberry", "sea2snailhouse", "sea2battlepass",
    "thanksgiving", "fruitshop", "resourceshop",
    "advgenerator1", "advgenerator2",
    "cinema",
    "dragonblue", "dragongreen", "dragonyellow", "dragonred", "dryeti", "drelf", "dragonpack", "dragonruby",
    "drfactory", "drrudolf", "drgiftaxe", "drgiftcuirass", "drgifthelm", "drgiftshield", "drgiftgenerator",
    "rprapunzel", "rpprince",
    "sealisa", "sealumberjack", "sealittlegirl", "seagranny", "seafisherman", "seascout", "walrusruby", "underseapack",
    "seagrowing", "seafactory", "searudolf", "seaanchor", "seawheel", "seaspyglass", "seapiratehook", "seagiftgenerator"
]);

Unit.INTACT_ENABLED = true;

Unit.MULTY_CELL_BODY_OCCUPIED_CELL = true;

Unit.SQUEEZE_DURATION = 200;
Unit.MINIMAL_SELL_LEVEL = 6;
Unit.MINIMAL_SELL_FOG = "fog3";

Unit.NEXT_CELL_CHECK_THRESHOLD = 0.35;

Unit.NOT_INTACT_COMPATIBLE = {
    main: ["mergecraft", "wondermerge", "fairy", "hustlemerge"],
    dragonia2: ["mergecraft", "wondermerge", "fairy"],
    dragonia3: ["mergecraft", "wondermerge", "fairy"],
    undersea2: ["mergecraft", "wondermerge", "fairy"],
    undersea3: ["mergecraft"],
    rapunzel2: ["mergecraft", "wondermerge", "fairy"],
    rapunzel3: ["mergecraft", "wondermerge", "fairy"],
    collections: ["mergecraft", "wondermerge", "fairy"]
};

Unit.DISABLED_MERGABLE_UNITS_FOR_CRYSTAL = [
    "coins",
    "rubies",
    "crystal"
];